"use client";

import { useEffect, useState } from "react";

import { IDocumentYear, IYearSelectProps } from "@/types";

const YearSelect = (props: IYearSelectProps) => {
  const { years, clickHandler, selectedYear } = props;

  const handleSelectYear = (year: number) => clickHandler(year);

  if (!years) return null;

  return (
    <div
      className={`
                flex
                items-center
                justify-center
                overflow-scroll
                no-scrollbar
            `}
    >
      {years.map((_year, idx) => (
        <div
          key={idx}
          className={`
                           px-[12px]
                           py-[15px]
                           cursor-pointer
                           ${selectedYear === _year.year ? "border-b-2 border-black text-black" : "border-b-2 border-gray-[40] text-gray-30"}
                        `}
          onClick={() => handleSelectYear(_year.year)}
        >
          {_year.year}
        </div>
      ))}
    </div>
  );
};

export default YearSelect;
